import { Action } from '@ngrx/store';

export enum EmissionPointIdAction {
  Set = '[EmissionPointId] Set',
  Reset = '[EmissionPointId] Reset',
  Sync = '[EmissionPointId] Sync',
}

export class Set implements Action {
  readonly type = EmissionPointIdAction.Set;

  constructor(public payload: number) {}
}

export class Reset implements Action {
  readonly type = EmissionPointIdAction.Reset;
}

export class Sync implements Action {
  readonly type = EmissionPointIdAction.Sync;

  constructor(public payload: number[]) {}
}

export type EmissionPointIdActionType = Set | Reset | Sync;
